
// ROUTES
require('modules/approvation-list/routes/approvation-list');

// CONTROLLERS
require('modules/approvation-list/controllers/approvation-list');
require('modules/approvation-list/controllers/list');
require('modules/approvation-list/controllers/list-zm');
require('modules/approvation-list/controllers/view-zm');
require('modules/approvation-list/controllers/list-am');
require('modules/approvation-list/controllers/view-am');
require('modules/approvation-list/controllers/create');
require('modules/approvation-list/controllers/edit');


// SERVICES
require('modules/approvation-list/services/approvation-list');
require('modules/approvation-list/services/list');
require('modules/approvation-list/services/create');
require('modules/approvation-list/services/edit');
require('modules/approvation-list/services/delete');




angular.module('unica_approvation_list', [

	// ROUTES
	'unica_approvation_list.approvation_list_routes',

	// CONTROLLERS
	'unica_approvation_list.approvation_list_controllers',

	// SERVICES
	'unica_approvation_list.approvation_list_services'

]);